import { CommonModule } from '@angular/common';
import { HttpHeaders } from '@angular/common/http';
import { inject, NgModule } from '@angular/core';
import { ApolloLink, InMemoryCache } from '@apollo/client/core';

import { provideApollo } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';

import { environment } from '../../environments/environment';
import { SharedModule } from '../shared/shared.module';

@NgModule({
	imports: [CommonModule, SharedModule],
	providers: [
		provideApollo(() => {
			const httpLink = inject(HttpLink);

			const headers = new HttpHeaders({
				'apollographql-client-name': 'Broker Web',
				'apollographql-client-version': '1.0.0',
			});
			return {
				cache: new InMemoryCache(),
				link: ApolloLink.from([
					httpLink.create({
						uri: environment.graphQLEndpoint,
						headers,
					}),
				]),
				name: 'Broker Web',
				version: '1.0.0',
				defaultOptions: {
					query: {
						fetchPolicy: 'no-cache',
					},
					mutate: {
						fetchPolicy: 'no-cache',
					},
				},
			};
		}),
	],
	declarations: [],
})
export class GraphqlModule {}
